import React from "react";
import { Line } from "react-chartjs-2";
import { MDBContainer } from "mdbreact";
import styles from "../CurrencyInfo.module.scss";

class ChartsCurrency extends React.Component {
  componentDidUpdate() {
    const lastData = 12;
    if (
      this.props.historyMonths?.length !== this.state.dataLine.labels?.length ||
      this.props.historyPrices[lastData] !==
        this.state.dataLine.datasets[0].data[lastData]
    ) {
      this.setState({
        dataLine: {
          ...this.state.dataLine,
          labels: this.props.historyMonths,
          datasets: [
            {
              ...this.state.dataLine.datasets[0],
              data: this.props.historyPrices,
            },
          ],
        },
      });
    }
  }
  state = {
    dataLine: {
      labels: this.props.historyMonths,
      datasets: [
        {
          label: this.props.name,
          fill: true,
          lineTension: 0.3,
          backgroundColor: "rgba(225, 204,230, .3)",
          borderColor: "rgb(205, 130, 158)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgb(205, 130,1 58)",
          pointBackgroundColor: "rgb(255, 255, 255)",
          pointBorderWidth: 5,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgb(0, 0, 0)",
          pointHoverBorderColor: "rgba(220, 220, 220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.props.historyPrices,
        },
      ],
    },
  };

  render() {
    return (
      <MDBContainer className={styles.chart}>
        <h3 className="mt-5">History</h3>
        <Line data={this.state.dataLine} options={{ responsive: true }} />
      </MDBContainer>
    );
  }
}

export default ChartsCurrency;
